import { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StParagraphContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
`;

const StParagraphNumber = styled.span`
    margin-right: 10px;
`;

const StParagraphText = styled.div``;
interface Props {
    number: string;
    children: ReactNode;
}
const TermsAndConditionsParagraph: FC<Props> = props => {
    return (
        <StParagraphContainer>
            <StParagraphNumber>{props.number}</StParagraphNumber>
            <StParagraphText>{props.children}</StParagraphText>
        </StParagraphContainer>
    );
};

export default TermsAndConditionsParagraph;
